import { downgradeInjectable } from '@angular/upgrade/static';
import { DataIndexAuthFacade, AiGatewayAuthFacade } from '@mode/shared/authorization/domain';
import * as angular from 'angular';

export const DowngradedSharedAuthorizationModule = angular
  .module('downgraded-shared-authorization', [])
  .service('AiGatewayAuthFacade', downgradeInjectable(AiGatewayAuthFacade))
  .service('DataIndexAuthFacade', downgradeInjectable(DataIndexAuthFacade)).name;
